// src/utils/errorHandler.ts
import { AxiosError } from "axios";

export const extractErrorMessage = (error: AxiosError): string => {
  if (error.response?.data) {
    const { message, subMessage } = error.response.data as any;
    return subMessage || message || "An unexpected error occurred.";
  }
  return error.message || "An unexpected error occurred.";
};
